import React from "react";
import { connect } from "react-redux";
import _ from "underscore";

import Logger, { LOG_LEVELS } from "../../../utils/log";
import ENUMS, { FilingTypeEnum } from "../../../utils/enums";
import LanguageStringResolver from "../../fields/language/LanguageStringResolver";
import LANGUAGE_CONTROLLER from "../../../controllers/languages";
import { SSelect } from "@avalara/skylab-sdk/react";

const log = new Logger("FILING_TYPE_SELECTOR", LOG_LEVELS.DEBUG);

export class FilingTypeSelector extends React.Component {
  selectionHandler(event) {
    log.debug("selectionHandler(): ", event);
    const filingType = { filingType: event.detail.item.value };
    this.props.selectionHandler(filingType);
  }

  getReturnTypeOptions() {
    let filingTypes = ENUMS.GetAllEnumOptions(FilingTypeEnum);

    if (this.props.filteredReturnTypes.length > 0) {
      filingTypes = this.props.filteredReturnTypes;
    }
    let optionsList = [
      {
        label: _.isString(this.props.selectValueLanguageStringKey)
          ? LANGUAGE_CONTROLLER.format(this.props.languageString, this.props.selectValueLanguageStringKey)
          : LANGUAGE_CONTROLLER.format(this.props.languageString, "SelectFilingType"),
        value: "",
      },
    ];
    filingTypes.forEach((filingType) => {
      optionsList.push({
        label: LANGUAGE_CONTROLLER.format(this.props.languageString, filingType),
        value: filingType,
        selected: this.props.filingType === filingType? true: false,
      });
    });
    return optionsList;
  }

  render() {
    log.debug("render(): ", this.props);

    return (
      <fieldset data-test="component-filing-type-selector" className={this.props.fieldsetClassName}>
        <label className="mr20">
          <LanguageStringResolver string="filterFilingType" />
        </label>
        <div data-test="component-return-type-selector" className="component-return-type-selector">
          <SSelect defaultValue={this.props.filingType} 
            inputId="return-type-single-select"
            name="returntypes"
            onS-select={this.selectionHandler.bind(this)}
            optionsList={this.getReturnTypeOptions() || []}
            multiple={false}
            showSelectionCount={false}
          />
        </div>
      </fieldset>
    );
  }
}


FilingTypeSelector.defaultProps = {
  fieldsetClassName: "",
  filteredReturnTypes: [],
};

// Wrap the component to inject state into it
export default connect(null)(FilingTypeSelector);
